<template>
  <div class="message is-info" v-if="ndc.note">
    <div class="message-header">
      <p>注</p>
    </div>
    <div class="message-body">
      <p v-for="(line, index) in ndc.note" :key="index">
        {{ line }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Note',
  props: [
    'ndc',
  ],
  data() {
    return {
    };
  },
};
</script>

<style scoped>
.message {
  margin-top: 1rem;
  bottom-top: 1rem;
}
</style>




// WEBPACK FOOTER //
// src/components/Note.vue